import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: '#1e3a5f', // Dark blue/navy matching wireframe
    color: 'white',
    fontSize: '12px',
    padding: '8px 12px',
    maxWidth: '280px',
    borderRadius: '4px',
  },
  arrow: {
    color: '#1e3a5f',
  },
  iconContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: '8px',
  },
  icon: {
    width: '20px',
    height: '20px',
    color: '#f59e0b', // Amber color matching the badge
  },
}));

/**
 * UnreachableTooltip - Warning icon with explanatory tooltip
 * Shows when a deployment is no longer reachable
 */
const UnreachableTooltip = ({ 
  id,
  tooltipText = "There's another deployment targeting these devices. This deployment won't work anymore.",
}) => {
  const classes = useStyles();

  return (
    <Tooltip
      title={tooltipText}
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      placement="top"
    >
      <span id={id} className={classes.iconContainer}>
        <ExclamationCircleIcon className={classes.icon} />
      </span>
    </Tooltip>
  );
};

UnreachableTooltip.propTypes = {
  id: PropTypes.string,
  tooltipText: PropTypes.string,
};

UnreachableTooltip.defaultProps = {
  id: undefined,
  tooltipText: "There's another deployment targeting these devices. This deployment won't work anymore.",
};

export default UnreachableTooltip;
